// Completion is stricter than display classification: explicit generated
// documents must never stand in for the automatic Patient Note.
export const getAutomaticNoteType = note => {
  // Persisted identifiers are authoritative. A generated referral must not
  // complete a recording even if its translated title or body says otherwise.
  if (typeof note?.document_kind === 'string' && note.document_kind) {
    if (note.document_kind === 'transcript') return 'Transcript';
    if (note.document_kind === 'patient_note') return 'Patient Note';
    return null;
  }
  if (typeof note?.note_type === 'string' && note.note_type) {
    if (note.note_type === 'Transcript') return 'Transcript';
    if (note.note_type === 'Patient Note') return 'Patient Note';
    return null;
  }
  const title = typeof note?.title === 'string' ? note.title.trim().toLowerCase() : '';
  if (title) {
    if (title === 'transcript') return 'Transcript';
    if (title === 'patient note') return 'Patient Note';
    return null;
  }
  // Legacy title-less notes are accepted only with an exact first heading.
  const text = typeof note?.note === 'string' ? note.note.trim() : '';
  const heading = text.split(/\r?\n/, 1)[0].trim().toLowerCase();
  if (heading === '# transcript') return 'Transcript';
  if (heading === '# patient note') return 'Patient Note';
  return null;
};
